import script from "./ClearFiltersButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ClearFiltersButton.vue?vue&type=script&setup=true&lang=js"

import "./ClearFiltersButton.vue?vue&type=style&index=0&id=5543c54c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5543c54c"]])

export default __exports__